import { z } from "zod";

const requestIdSchema = z.string().uuid();

/** The host can map its route to this query parameter without granting access. */
export function requestIdFromSearch(search: string): string | null {
  const values = new URLSearchParams(search).getAll("requestId");
  if (values.length !== 1) return null;
  const parsed = requestIdSchema.safeParse(values[0]);
  return parsed.success ? parsed.data : null;
}

export function requestSelectionUrl(href: string, requestId: string | null): string {
  const url = new URL(href);
  if (requestId === null) url.searchParams.delete("requestId");
  else {
    const parsed = requestIdSchema.safeParse(requestId);
    if (!parsed.success) throw new Error("Geçerli talep bağlantısı gerekli.");
    url.searchParams.set("requestId", parsed.data);
  }
  return url.href;
}
